<template>
  <div :class="{ 'primary-input': true, invalid: invalid, showUnlinkOnHover: true }">
    <input
      :type="type"
      ref="input"
      :value="modelValue"
      :disabled="disabled || readonly"
      :placeholder="placeholder"
      @input="updateValue"
      @keyup="handleFormatPhoneNumber"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :class="{ 'input-with-link': showExtLink, readonly: readonly }" />
    <label>{{ label }}</label>
    <label v-if="required && invalid" class="required">Required Field</label>
    <img v-if="showExtLink" src="../../assets/external-link.svg" alt="" class="external-link" @click="$emit('navigateToLink')" />
    <div class="hover-icon-link-container" v-if="showPlus" @click="$emit('handlePlus')" title="Link Company">
      <img id="noHover" src="../../assets/plus-btn.svg" />
      <img id="hover" src="../../assets/plus-btn-hover.svg" />
    </div>
    <div class="hover-icon-link-container unlink" v-if="showUnlink" @click="$emit('handleUnlink')" title="Unlink Company">
      <img id="noHover" src="../../assets/unlink.svg" />
      <img id="hover" src="../../assets/unlink-hover.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextBox',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: '',
    },
    showExtLink: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    showPlus: {
      type: Boolean,
      default: false,
    },
    showUnlink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'blur', 'focus', 'navigateToLink', 'handlePlus', 'handleUnlink'],
  methods: {
    updateValue(event) {
      if (this.format === 'phone') {
        this.handleFormatPhoneNumber();
      } else {
        if (!this.readonly) {
          this.$emit('update:modelValue', event.target.value);
        }
      }
    },
    handleFormatPhoneNumber() {
      if (this.format === 'phone') {
        const formatted = this.formatPhoneNumber(this.$refs.input.value);
        this.$refs.input.value = formatted;
        this.$emit('update:modelValue', formatted);
      }
    },
    formatPhoneNumber(value) {
      // Remove all non-numeric characters
      const cleaned = value.replace(/\D/g, '');

      // Limit to 13 digits max
      const limited = cleaned.slice(0, 13);

      if (limited.length === 0) {
        return '';
      }

      // Format based on length
      if (limited.length <= 10) {
        // Standard US format: (xxx) xxx-xxxx
        if (limited.length <= 3) {
          return limited;
        } else if (limited.length <= 6) {
          return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
        } else {
          return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
        }
      } else {
        // International format: +xxx (xxx) xxx-xxxx
        const countryCodeLength = limited.length - 10;
        const countryCode = limited.slice(0, countryCodeLength);
        const areaCode = limited.slice(countryCodeLength, countryCodeLength + 3);
        const firstPart = limited.slice(countryCodeLength + 3, countryCodeLength + 6);
        const secondPart = limited.slice(countryCodeLength + 6);

        return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
      }
    },
  },
  mounted() {
    if (this.format === 'phone') {
      this.handleFormatPhoneNumber();
    }
  },
};
</script>

<style lang="scss" scoped>
.primary-input input.input-with-link {
  padding-right: 2.5rem !important;
}

.hover-icon-link-container {
  position: absolute;
  top: 0.65rem;
  right: 0.67rem;
  cursor: pointer;

  img {
    height: 1.7rem;
  }

  #noHover {
    display: block;
  }

  #hover {
    display: none;
  }

  &:hover {
    #noHover {
      display: none;
    }

    #hover {
      display: block;
    }
  }
}

.unlink {
  display: none;
  right: 2.9rem;
}

.showUnlinkOnHover {
  &:hover {
    .unlink {
      display: block;
    }
  }
}

.external-link {
  position: absolute;
  top: 0.75rem;
  right: 0.8rem;
  height: 1.5rem;
  cursor: pointer;
}
</style>
